import { render, staticRenderFns } from "./sysrole.vue?vue&type=template&id=1b8e444c&scoped=true"
import script from "./sysrole.vue?vue&type=script&lang=js"
export * from "./sysrole.vue?vue&type=script&lang=js"
import style0 from "./sysrole.vue?vue&type=style&index=0&id=1b8e444c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8e444c",
  null
  
)

export default component.exports